import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import RealTimeSpeechToText from "./Utils/RealTimeSpeechToText";
//import GoogleVoiceToText from "./Utils/GoogleVoiceToText";
//import GoogleRealTimeVoiceToText from "./Utils/GoogleRealTimeVoiceToText";
import AzureCTD from "./Utils/ClicktoDial";
import TwilioClicktoDial from "./Utils/TwilioClicktoDial.js";


const App = () => {
  return (
    <Router>
      {/* <nav className="navbar">
        <ul className="nav-links">
          <li><Link to="/">Click to Dial - Azure </Link></li>
          <li><Link to="/twilio">Click to Dial - Twilio</Link></li>
          <li><Link to="/speechtotext">Azure Speech to Text (Realtime)</Link></li>
        </ul>
      </nav> */}

      <Routes>
        <Route path="/" element={<AzureCTD />} />
        <Route path="/twilio" element={<TwilioClicktoDial />} />
        <Route path="/speechtotext" element={<RealTimeSpeechToText />} />
        {/* 
        <Route path="/googlevoicetotext" element={<GoogleVoiceToText />} />
        <Route path="/googlerealtimevoicetotext" element={<GoogleRealTimeVoiceToText />} />
        <Route path="/googlerealtime" element={<GoogleRealTimeVoiceToText />} /> */}
      </Routes>
    </Router>
  );
};

export default App;